module.exports = __webpack_public_path__ + "img/Technologue_lait_7_TPA.5ae43430.jpg";